/**
 * defa.views.InvitationFlow
 * A flow for approving or rejecting invitations for a token.
 * @version 1.0.0
 */
import Flow           from 'scripts/poppet/flow';
import InvitationView from 'scripts/defa/invitations/view-invitation-view';
import User           from 'scripts/defa/users/model-user';
import UserContainer from 'scripts/defa/users/view-user-container';
import template      from 'templates/invitationFlow.jst.html'


const channelUser   = Bb.Radio.channel( 'user'   );

const selectors = {
	template : '[data-template=invitation-flow]',
	region   : '[data-region=invitation-flow-container]',
};

const InvitationFlow = Flow.extend({
		
		// ------------------------------------------------
		// Setup
		// ------------------------------------------------
		
	template: template,
	
	regions: {
		container: selectors.region,
	},
		
		
		
		// ------------------------------------------------
		// Event Handlers
		// ------------------------------------------------
		
		// ------------------------------------------------
		// Other functions
		// ------------------------------------------------
		
		/**
		 * Shows the the login or create form based on the context.
		 * @void
		 */
	_showLogin: function() {
		let self  = this;
		self.currentUser = new User();
		
		let userContainer = new UserContainer({
			user        : self.user,
			currentUser : self.currentUser,
			email       : this.options.email,
			view        : this.options.context,
			token       : this.options.token || '',
			navHandler  : 'internal',
		});
			
			// if end user creates a new customer, show the happy ending.
		self.listenToOnce( self.currentUser, 'sync', function( model ) {
			userContainer.settings({
				view: 'user:thank-you',
			});
		});
		
		self.listenToOnce( self.user, 'sync', function( model ) {
			self.dispatch();
		});
		self.showChildView( 'container', userContainer );
	},
		
		/**
		 * Dispaches the invitation flow.
		 * @void
		 */
	dispatch: function() {
		this.user       = channelUser.request( 'model' );
		this.loggedIn   = channelUser.request( 'is:logged:in' );
		
		if( !this.loggedIn ) {
			this._showLogin();
		}else{
			this._showInvitationsWithToken()
		}
	},
		
		/**
		 * Shows invitations with the token.
		 * @void
		 */
	_showInvitationsWithToken: function () {
		let invitationView = new InvitationView(_.extend( this.options,{
			model: this.options.invitation
		}));
		this.showChildView( 'container', invitationView );
	}
});

export default InvitationFlow;
